import { render, staticRenderFns } from "./Kassenbuch.vue?vue&type=template&id=2c446032&"
import script from "./Kassenbuch.vue?vue&type=script&lang=ts&"
export * from "./Kassenbuch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports